export const categorysList=[
    {
        value:1,
        name:'视听作品'
    },
    {
        value:2,
        name:'文字作品'
    },
    {
        value:3,
        name:'摄影作品'
    },
    {
        value:4,
        name:'美术作品'
    },
    {
        value:5,
        name:'音乐作品'
    },
    {
        value:6,
        name:'设计作品'
    },
    {
        value:7,
        name:'口述作品'
    },
    {
        value:8,
        name:'戏剧曲艺作品'
    },
    {
        value:9,
        name:'舞蹈杂技作品'
    },
    {
        value:10,
        name:'建筑作品'
    },
    {
        value:11,
        name:'图形作品'
    },
    {
        value:12,
        name:'模型作品'
    },
    {
        value:13,
        name:'计算机软件'
    },
    {
        value:0,
        name:'其它'
    },
]

export const fileType=[
    {
        name:'商业秘密',
        value: 109,
    },
    {
        name:'工业项目',
        value: 119,
    },
    {
        name:'软件项目',
        value: 108,
        relatedID: 13, //关联ID
    },
    {
        name:'硬件项目',
        value: 120,
    },
    {
        name:'科研成果',
        value: 121,
    },
    {
        name:'数据资产',
        value: 122,
    },
    {
        name:'商标设计',    
        value: 123,
    },
    {
        name:'专利文档',
        value: 124,
    },
    {
        name:'文字作品',   
        value: 101,
        relatedID: 2, //关联ID
    },
    {
        name:'摄影作品',
        value: 110,
        relatedID: 3, //关联ID
    },
    {
        name:'美术作品',
        value: 104,
        relatedID: 4, //关联ID
    },
    {
        name:'音乐作品',
        value: 102,
        relatedID: 5, //关联ID
    },
    {
        name:'设计作品',
        value: 105,
        relatedID: 6, //关联ID
    },
    {
        name:'讲义课件',
        value: 125,
    },
    {
        name:'视听作品',
        value: 112,
        relatedID: 1, //关联ID
    },
    {
        name:'口述作品',
        value: 132,
        relatedID: 7, //关联ID
    },
    {
        name:'戏剧曲艺作品',
        value: 133,
        relatedID: 8, //关联ID
    },
    {
        name:'舞蹈杂技作品',
        value: 134,
        relatedID: 9, //关联ID
    },
    {
        name:'建筑作品',
        value: 135,
        relatedID: 10, //关联ID
    },
    {
        name:'图形作品',
        value: 136,
        relatedID: 11, //关联ID
    },
    {
        name:'模型作品',
        value: 137,
        relatedID: 12, //关联ID
    },
    {
        name:'其它',
        value: 999,
        relatedID: 0, //关联ID
    },
]